import React from 'react';
import PropTypes from 'prop-types';
import Button from 'antd/lib/button';
import { translate } from 'react-i18next';

function ShowPsd2ButtonBase({ loans, onOpenPsd2, psd2Enabled, t }) {
  if(!psd2Enabled){return null}
  const safeLoans = Array.isArray(loans) ? loans : [];

  let hasFinished = false;
  let hasDeleted = false;
  let hasStarted = false;

  safeLoans.forEach((loan) => {
    if (Array.isArray(loan.psd2Requisitions)) {
      if (loan.psd2Requisitions.some((r) => r && r.system_status === 'deleted')) {
        hasDeleted = true;
      }
      if (loan.psd2Requisitions.some((r) => r && r.system_status === 'new' && r.status === 'CR')) {
        hasStarted = true;
      }
      if (loan.psd2Requisitions.filter((r) => r && r.system_status !== 'deleted' && (r.status === 'LN' || r.status === 'EX')).length > 0) {
        hasFinished = true;
      }
    }
  });

  // 1) Finished → active button
  if (hasFinished) {
    return (
      <div style={{ marginTop: 12 }}>
        <Button size="default" onClick={onOpenPsd2}>
          {t('Zobraziť PSD2 výpisy')}
        </Button>
      </div>
    );
  }

  // 2) Started → disabled button
  if (hasStarted) {
    return (
      <div style={{ marginTop: 12 }}>
        <Button size="default" disabled>
          {t('Prebieha sťahovanie transakcií.')}
        </Button>
      </div>
    );
  }

  // 3) Deleted → disabled button
  if (hasDeleted) {
    return (
      <div style={{ marginTop: 12 }}>
        <Button size="default" disabled>
          {t('Transakcie z PSD2 boli vymazané.')}
        </Button>
      </div>
    );
  }

  // 4) Nothing to show
  return null;
}

ShowPsd2ButtonBase.propTypes = {
  loans: PropTypes.array.isRequired,
  onOpenPsd2: PropTypes.func.isRequired,
  psd2Enabled: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export const ShowPsd2Button = translate()(ShowPsd2ButtonBase);
export default ShowPsd2Button;



// WEBPACK FOOTER //
// ./src/features/account-management/components/psd2/ShowPsd2Button.js